<template>
  <modal
    class="modal"
    :name="name"
    :pivotY="0.1"
    :width="300"
    height="auto"
    overlayTransition=""
    @closed="$emit('closed')"
  >
    <div class="text">
      <slot></slot>
    </div>
    <div class="buttons">
      <slot name="footer"></slot>
    </div>
  </modal>
</template>

<script>
export default {
  props: ['name'],
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.modal::v-deep {
  .vm--modal {
    background-color: var(--bg);
    border: 2px solid var(--lighter-primary);
  }

  .vm--overlay {
    background: rgba(0, 0, 0, var(--modal-overlay-opacity));
  }

  .input {
    display: block;
    border: 1px solid var(--tertiary-accent);
    background-color: var(--tertiary-bg);
    color: var(--text-primary);
    border-radius: 2px;
    padding: 6px;
    font-size: 14px;
    margin-top: 5px;
    width: 100%;

    @include notebook {
      font-size: 16px;
    }
  }

  .buttons {
    display: flex;
    padding: 10px 15px 15px;
    border-top: 1px solid var(--tertiary-accent);

    button:last-child {
      margin-left: auto;
    }
  }

  .text {
    padding: 15px 15px 10px;
  }
}
</style>
